<template>
	<span :title="model">
		<v-combobox
			:hint="hint"
			multiple
			@change="updateCombo()"
			v-model="model"
			:label="label"
			:disabled="inputDisabled"
			append-icon
			persistent-hint
			chips
			:type="combotype"
			deletable-chips
			:rules="computedRules"
		>
		</v-combobox>
	</span>
</template>

<script>
import BaseInput from './baseInput'
export default {
	extends: BaseInput,
	props: ['combotype'],
	methods: {
		updateCombo() {
			if (this.model.length > 0) {
				let lastItem = this.model.splice(this.model.length - 1, 1)[0]
				let items = lastItem.split(/,|;/).filter((el) => el.length > 0)
				this.model = this.model.concat(items)
			}
			this.update()
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/baseComponents/inputs/comboboxInput.vue